import React from "react";
import { Star, Award, Wrench, Users } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const AboutUpdated = () => {
  const features = [{
    icon: <Star className="h-6 w-6 md:h-8 md:w-8 text-garage-blue" />,
    title: "Jakość",
    description: "Najwyższa jakość usług i używanych produktów. Zawsze dopasowane do potrzeb Twojego auta."
  }, {
    icon: <Award className="h-6 w-6 md:h-8 md:w-8 text-garage-blue" />,
    title: "Doświadczenie",
    description: "Praktyka nie tylko w autodetailingu, ale również w czyszczeniu wnętrz użytkowych."
  }, {
    icon: <Wrench className="h-6 w-6 md:h-8 md:w-8 text-garage-blue" />,
    title: "Profesjonalne urządzenia",
    description: "Korzystamy z profesjonalnego sprzętu i środków chemicznych dedykowanych do pielęgnacji pojazdów."
  }, {
    icon: <Users className="h-6 w-6 md:h-8 md:w-8 text-garage-blue" />,
    title: "Mobilność",
    description: "Pracujemy tam, gdzie jest Twój pojazd, ale również lokalnie na ulicy Bluszczowej."
  }];

  return (
    <section id="about" className="section-spacing bg-gradient-to-b from-garage-darker to-garage-dark">
      <div className="container-spacing">
        <h2 className="section-title text-center fade-in-fast">
          O nas
        </h2>
        
        <div className="text-center max-w-3xl mx-auto mb-12 fade-in-fast">
          <p className="text-white font-medium text-lg md:text-xl leading-relaxed">
            <span className="block mb-2">
              W sercu Poznania dbamy o każdy detal.
            </span>
            Oto, czym zdobywamy zaufanie klientów:
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div key={feature.title} className="fade-in-fast">
              <Card className="bg-black border-white/20 hover:border-garage-blue transition-colors h-full shadow-lg hover:shadow-blue-900/20 backdrop-blur-sm card-hover">
                <CardContent className="p-6">
                  <div className="flex justify-center items-center mb-4 h-12 w-12 md:h-16 md:w-16 rounded-full bg-garage-dark mx-auto">
                    {feature.icon}
                  </div>
                  <h3 className="text-lg md:text-xl font-semibold mb-3 text-white text-center">
                    {feature.title}
                  </h3>
                  <p className="text-sm md:text-base text-white/90 text-center leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutUpdated;